import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FatafatDollarState {
    isFatafatDollarLoading: boolean;
    fatafatDollarMsg: string;
    fatafatDollarGamesData: any;
    isFatafatDollarDataFailed: boolean;
    fatafatDollarGameRateData: any;
    isFatafatDollarGameRateFailed: boolean;
    fatafatDollarGameTypesData: any;
    isFatafatDollarGameTypesFailed: boolean;
    fatafatDollarGameStatusData: any;
    isFatafatDollarGameStatusFailed: boolean;
    isSubmitFatafatDollarBidSuccess: boolean;
    isSubmitFatafatDollarBidFailed: boolean;
    fatafatDollarBidHistoryData: any;
    isFatafatDollarBidHistoryDataFailed: boolean;
    fatafatDollarWinningHistoryData: any;
    isFatafatDollarWinningHistoryDataFailed: boolean;
    fatafatDollarResultsData: any;
    isFatafatDollarResultsFailed: boolean;
    menuName: string;
}

const initialState: FatafatDollarState = {    
    isFatafatDollarLoading: false,
    fatafatDollarMsg: '',
    fatafatDollarGamesData: {},
    isFatafatDollarDataFailed: false,
    fatafatDollarGameRateData: {},
    isFatafatDollarGameRateFailed: false,
    fatafatDollarGameTypesData: {},
    isFatafatDollarGameTypesFailed: false,
    fatafatDollarGameStatusData: {},
    isFatafatDollarGameStatusFailed: false,
    isSubmitFatafatDollarBidSuccess: false,
    isSubmitFatafatDollarBidFailed: false,
    fatafatDollarBidHistoryData: {},
    isFatafatDollarBidHistoryDataFailed: false,
    fatafatDollarWinningHistoryData: {},
    isFatafatDollarWinningHistoryDataFailed: false,
    fatafatDollarResultsData: {},
    isFatafatDollarResultsFailed: false,
    menuName: ''
}

const fatafatDollarReducer = createSlice({
    name: 'fatafatdollar',
    initialState: initialState,
    reducers: {
        // Get Games
        fatafatDollarGamesReq: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = true;
        },
        fatafatDollarGamesRes: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarGamesData = action.payload.res;
        },
        fatafatDollarGamesFailed: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarGamesData = {};
            state.isFatafatDollarDataFailed = true;
            state.fatafatDollarMsg = action.payload?.res?.msg || 'Failed to load games';
        },

        // Get Game Rates
        fatafatDollarGameRatesReq: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = true;
        },
        fatafatDollarGameRatesRes: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarGameRateData = action.payload.res;
        },
        fatafatDollarGameRatesFailed: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.isFatafatDollarGameRateFailed = true;
            state.fatafatDollarMsg = action.payload?.res?.msg || 'Failed to load rates';
        },

        // Get Game Types
        fatafatDollarGameTypesReq: (state) => {
            state.isFatafatDollarLoading = true;
        },
        fatafatDollarGameTypesRes: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarGameTypesData = action.payload.res;
        },
        fatafatDollarGameTypesFailed: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.isFatafatDollarGameTypesFailed = true;
            state.fatafatDollarMsg = action.payload?.res?.msg || 'Failed to load game types';
        },

        // Check Game Status
        fatafatDollarGameStatusReq: (state) => {
            state.isFatafatDollarLoading = true;
        },
        fatafatDollarGameStatusRes: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarGameStatusData = action.payload.res;           
        },
        fatafatDollarGameStatusFailed: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.isFatafatDollarGameStatusFailed = true;
            state.fatafatDollarGameStatusData = {};
            state.fatafatDollarMsg = action.payload?.res?.msg || 'Failed to check game status';
        },

        // Submit Bid
        submitFatafatDollarBidReq: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = true;
        },
        submitFatafatDollarBidRes: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.isSubmitFatafatDollarBidSuccess = true;
            state.isSubmitFatafatDollarBidFailed = false;
            state.fatafatDollarMsg = action.payload?.res?.msg || 'Bid submitted successfully';
        },
        submitFatafatDollarBidFailed: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.isSubmitFatafatDollarBidSuccess = false;
            state.isSubmitFatafatDollarBidFailed = true;
            state.fatafatDollarMsg = action.payload?.res?.msg || 'Failed to submit bid';
        },

        // Get Bid History
        fatafatDollarBidHistoryReq: (state) => {
            state.isFatafatDollarLoading = true;
        },
        fatafatDollarBidHistoryRes: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarBidHistoryData = action.payload.res;
        },
        fatafatDollarBidHistoryFailed: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.isFatafatDollarBidHistoryDataFailed = true;
            state.fatafatDollarBidHistoryData = {};
            state.fatafatDollarMsg = action.payload?.res?.msg || 'Failed to load bid history';
        },

        // Get Winning History
        fatafatDollarWinningHistoryReq: (state) => {
            state.isFatafatDollarLoading = true;
        },
        fatafatDollarWinningHistoryRes: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarWinningHistoryData = action.payload.res;
        },
        fatafatDollarWinningHistoryFailed: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarWinningHistoryData = {};
            state.isFatafatDollarWinningHistoryDataFailed = true;
            state.fatafatDollarMsg = action.payload?.res?.msg || 'Failed to load winning history';
        },

        // Get Results
        fatafatDollarResultsReq: (state) => {
            state.isFatafatDollarLoading = true;
        },
        fatafatDollarResultsRes: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarResultsData = action.payload.res;
        },
        fatafatDollarResultsFailed: (state, action: PayloadAction<any>) => {
            state.isFatafatDollarLoading = false;
            state.isFatafatDollarResultsFailed = true;
            state.fatafatDollarResultsData = {};
            state.fatafatDollarMsg = action.payload?.res?.msg || 'Failed to load results';
        },

        // Set Menu Name
        setFatafatDollarMenuName: (state, action: PayloadAction<string>) => {
            state.menuName = action.payload;
        },

        // Reset State
        resetFatafatDollar: (state) => {
            state.isFatafatDollarLoading = false;
            state.fatafatDollarMsg = '';
            state.isFatafatDollarDataFailed = false;
            state.isFatafatDollarGameRateFailed = false;
            state.isFatafatDollarGameTypesFailed = false;
            state.isFatafatDollarGameStatusFailed = false;
            state.isFatafatDollarBidHistoryDataFailed = false;
            state.isFatafatDollarWinningHistoryDataFailed = false;
            state.isFatafatDollarResultsFailed = false;
            state.isSubmitFatafatDollarBidSuccess = false;
            state.isSubmitFatafatDollarBidFailed = false;
        }
    }
})

export const fatafatDollarActions = fatafatDollarReducer.actions;
export default fatafatDollarReducer;

